<template>
    <div class="app">
        <div
            class="main"
            id="main"
            @click="sidebarOpen ? (sidebarOpen = false) : null"
        >
            <router-view v-slot="{ Component }">
                <transition :name="pageTransitionName">
                    <component :is="Component" />
                </transition>
            </router-view>
            <div class="copyright">&copy; Modern Arts Midtown</div>
        </div>
        <div class="sidebar" :class="{ open: sidebarOpen }">
            <ul class="links">
                <li>
                    <router-link to="/"
                        ><div class="logo">
                            <img
                                alt="Modern Arts Midtown"
                                src="./assets/logo.png"
                                width="390" height="344"
                            /></div
                    ></router-link>
                </li>
                <li>
                    <router-link to="/collection"
                        >Artist Collection</router-link
                    >
                </li>
                <li><router-link to="/search?keyword=sculpture"
                    active-class="router-link-active-nostyle"
                    >Sculpture</router-link></li>
                <li><router-link to="/events">Now Showing</router-link></li>
                <li><router-link to="/search">Search</router-link></li>
                <li><router-link to="/favorites">Favorites</router-link></li>
                <li><router-link to="/contact">Contact</router-link></li>
            </ul>
            <div class="search">
                <input
                    type="search"
                    placeholder="🔎︎"
                    @change="searchDone"
                    @keydown.enter="searchDone"
                    v-model="search"
                />
            </div>
            <div class="footer">
                <p>
                    Open by appointment<br />
                    Tues&mdash;Sat | 11-6pm
                </p>
                <p>
                    402.502.8737<br />
                    3615 Dodge St, Omaha, NE
                </p>
                <p>
                    <router-link to="/contact"
                        ><span class="icon material-icons-outlined"
                            >email</span
                        ></router-link
                    >
                    <a
                        href="https://www.facebook.com/ModernArtsMidtown/"
                        target="_blank"
                        rel="noopener"
                        ><span class="icon material-icons">facebook</span></a
                    >
                    <a
                        href="https://www.instagram.com/modern.arts.midtown/"
                        target="_blank"
                        rel="noopener"
                        ><img class="icon" src="./assets/instagram.png" height="20" width="20" /></a
                    >
                </p>
            </div>
            <!-- /footer -->
        </div>
        <!-- /sidebar -->
        <div
            class="mobile-header"
            @click="sidebarOpen ? (sidebarOpen = false) : null"
        >
            <router-link to="/" class="home"
                ><div class="logo">
                    <img
                        alt="Modern Arts Midtown"
                        src="./assets/logo.png"
                    /></div
            ></router-link>
            <h4>Modern Arts Midtown</h4>
            <a class="sidebar-toggle" @click.stop="sidebarOpen = !sidebarOpen"
                ><span class="material-icons">menu</span></a
            >
        </div>
    </div>
    <!-- /app -->
</template>

<script>
import { Search } from "@/state.js";
import { nextTick } from "vue";

export default {
    name: "App",
    created() {
        const vm = this;
        vm.$router.afterEach(async (/*to, from*/) => {
            vm.sidebarOpen = false;

            // dont animate on first page load
            if (vm.pageTransitionName == "page") return;
            await nextTick();
            vm.pageTransitionName = "page";
        });
        // vm.$router.beforeEach(() => {
        //   vm.sidebarOpen = false;
        // });

        const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
        if (isMacLike) document.querySelector('body').classList.add('mac');
    },
    data() {
        return {
            search: Search,
            sidebarOpen: false,
            pageTransitionName: "",
        };
    },
    methods: {
        searchDone() {
            const vm = this;
            vm.$router.push({ name: "search" });
        },
    },
};
</script>

<style lang="scss">
@import "./assets/main.scss";
</style>
